import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const TabbarWrapper = styled.div`
  padding: 24px 16px 16px;
`

export const Content = styled.div`
  ${customizeVerticalScrollbarThumbMixin()}
  overflow: auto;
  flex: 1;
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const VideoItemWrapper = styled.div`
  position: relative;
  & > :first-child {
    border-bottom: none;
  }
`

export const GradientDivider = styled.div`
  flex-shrink: 0;
  height: 1px;
  margin-top: 12px;
  background: linear-gradient(
    270deg,
    rgba(221, 227, 240, 0) 0%,
    rgba(221, 227, 240, 1) 50%,
    rgba(221, 227, 240, 0) 100%
  );
`
